import {
  Box,
  Grid,
  Button,
  Typography,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import usePostData from "../../../utility/usePostData";

const CardDeclaration = (props) => {
  const { declaration, refreshSearch } = props;
  const history = useHistory();
  const { submitData } = usePostData();

  const statusStyle = (status) => {
    switch (status) {
      case 1:
        return "#fff";
      case 0:
        return "rgba(0, 166, 82, 0.05)";
      default:
        return "#fff";
    }
  };

  const deleteDeclaration = (declaration) => {
    const result = window.confirm("êtes-vous sûr ? ");
    if (result) {
      submitData("online_declaration_detaches/" + declaration, {}, "DELETE");
      refreshSearch();
    }
  };

  return (
    <Card
      sx={{
        backgroundColor: statusStyle(declaration.is_opened),
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        },
        border: "1px solid #eee",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        {declaration && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <Typography
                variant="h6"
                sx={{
                  color: "#00a652",
                  fontWeight: 500,
                  mb: 1,
                  textAlign: { xs: "left", md: "left" },
                }}
              >
                {declaration.titre}
              </Typography>

              <Box sx={{ mb: 1 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: { xs: "left", md: "left" } }}
                >
                  Date de déclaration:{" "}
                  <strong>{declaration?.date_declaration}</strong>
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  Transmis le: {declaration.created_at}
                </Typography>

                {declaration?.user && (
                  <Chip
                    label={`Par: ${declaration.user.name}`}
                    size="small"
                    sx={{
                      backgroundColor: "#00a652",
                      color: "white",
                      mb: 2,
                    }}
                  />
                )}

                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                  }}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<DeleteIcon />}
                    onClick={() => deleteDeclaration(declaration.id)}
                    sx={{
                      color: "#ec1a20",
                      borderColor: "#ec1a20",
                      "&:hover": {
                        backgroundColor: "rgba(236,26,32,0.04)",
                        borderColor: "#ec1a20",
                      },
                    }}
                  >
                    Supprimer
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<PreviewIcon />}
                    onClick={() =>
                      history.push(`show-detail-declaration/${declaration.id}`)
                    }
                    sx={{
                      backgroundColor: "#00a652",
                      "&:hover": {
                        backgroundColor: "#00a652",
                      },
                    }}
                  >
                    Lire
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default CardDeclaration;
